/** @jsxImportSource @emotion/react */

interface Props {
  elevation?: number;
  children?: React.ReactNode | React.ReactNode[];
  sx?: React.CSSProperties;
}
const Paper = ({ elevation = 0, children, sx }: Props) => {
  const getShadow = () => {
    if (!elevation) return 'none';

    return `${elevation / 2}px ${elevation}px ${3 + elevation * 2}px gray`;
  };

  return (
    <div
      css={{
        boxShadow: getShadow(),
        borderRadius: '4px',
        background: 'white',
        ...(sx ? sx : {}),
      }}
    >
      {children}
    </div>
  );
};

export default Paper;
